import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("owner@bholajewellers.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin/dashboard", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back, " + (u.name || u.email));
      if (u.must_change_password) {
        toast("Please change your password from the Settings panel.", { duration: 6000 });
      }
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatError(err?.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-md glass p-10 space-y-6" data-testid="admin-login-form">
        <div className="text-center">
          <div className="w-14 h-14 mx-auto mb-4 rounded-full border border-rose-gold/40 flex items-center justify-center">
            <KeyRound className="w-6 h-6 text-rose-gold" />
          </div>
          <h1 className="font-display text-3xl text-ivory" style={{ fontWeight: 300 }}>Owner Sign-in</h1>
          <p className="text-ivory/50 text-sm mt-2">Bholaa Jewels · Est. 1966</p>
        </div>
        <div className="space-y-3">
          <div>
            <label className="overline text-ivory/50">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full bg-ink-900 border border-white/10 px-4 py-3 text-ivory focus:border-rose-gold"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="overline text-ivory/50">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-ivory/40" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full bg-ink-900 border border-white/10 pl-10 pr-4 py-3 text-ivory focus:border-rose-gold"
                data-testid="login-password"
              />
            </div>
          </div>
        </div>
        <button type="submit" disabled={loading} className="w-full bg-rose-gold text-ink-900 py-4 font-medium tracking-widest uppercase text-sm hover:bg-champagne disabled:opacity-50" data-testid="login-submit">
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <p className="text-[11px] text-ivory/40 text-center">
          Default password on first login: <code className="text-rose-gold/70">bhola@1966</code> — please change it from Settings.
        </p>
      </form>
    </div>
  );
}
